/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Language } from '../models/Language';
import type { ListOf1OfShowcaseItemAdminDto } from '../models/ListOf1OfShowcaseItemAdminDto';
import type { Pagination1OfShowcaseAdminListedDto } from '../models/Pagination1OfShowcaseAdminListedDto';
import type { Pagination1OfShowcaseBranchAdminDto } from '../models/Pagination1OfShowcaseBranchAdminDto';
import type { Pagination1OfShowcaseListedClientDto } from '../models/Pagination1OfShowcaseListedClientDto';
import type { PostShowcaseRequestAdmin } from '../models/PostShowcaseRequestAdmin';
import type { PutShowcaseBranchOrderRequestAdmin } from '../models/PutShowcaseBranchOrderRequestAdmin';
import type { PutShowcaseBranchRequestAdmin } from '../models/PutShowcaseBranchRequestAdmin';
import type { PutShowcaseItemRequestAdmin } from '../models/PutShowcaseItemRequestAdmin';
import type { PutShowcaseOrderRequestAdmin } from '../models/PutShowcaseOrderRequestAdmin';
import type { PutShowcaseRequestAdmin } from '../models/PutShowcaseRequestAdmin';
import type { ScopeType } from '../models/ScopeType';
import type { ShowcaseAdminDto } from '../models/ShowcaseAdminDto';
import type { ShowcaseClientDto } from '../models/ShowcaseClientDto';
import type { ShowcaseModeType } from '../models/ShowcaseModeType';
import type { ShowcaseType } from '../models/ShowcaseType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShowcasesService {
    /**
     * @returns ShowcaseClientDto OK
     * @throws ApiError
     */
    public static getShowcaseClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<ShowcaseClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/showcases/{id}/public',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns Pagination1OfShowcaseListedClientDto OK
     * @throws ApiError
     */
    public static getPublicShowcasesClient({
        language,
        channelId,
        type,
        currentLocationLng,
        currentLocationLat,
        scopeTypes,
        page,
        limit,
    }: {
        language: Language,
        channelId?: number,
        type?: ShowcaseType,
        currentLocationLng?: number,
        currentLocationLat?: number,
        scopeTypes?: Array<ScopeType>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShowcaseListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/showcases/public',
            query: {
                'language': language,
                'channelId': channelId,
                'type': type,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
                'scopeTypes': scopeTypes,
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * @returns Pagination1OfShowcaseListedClientDto OK
     * @throws ApiError
     */
    public static getShowcasesClient({
        channelId,
        branchId,
        type,
        userAddressId,
        scopeTypes,
        page,
        limit,
    }: {
        channelId?: number,
        branchId?: number,
        type?: ShowcaseType,
        userAddressId?: number,
        scopeTypes?: Array<ScopeType>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShowcaseListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/showcases',
            query: {
                'channelId': channelId,
                'branchId': branchId,
                'type': type,
                'userAddressId': userAddressId,
                'scopeTypes': scopeTypes,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShowcaseDetails`
     * @returns Pagination1OfShowcaseBranchAdminDto OK
     * @throws ApiError
     */
    public static getBranchesByShowcaseAdmin({
        id,
        branchId,
        serviceId,
        page,
        limit,
    }: {
        id: number,
        branchId?: number,
        serviceId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShowcaseBranchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/showcases/{id}/branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
                'serviceId': serviceId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static putShowcaseBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutShowcaseBranchRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcases/{id}/branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShowcaseDetails`
     * @returns ListOf1OfShowcaseItemAdminDto OK
     * @throws ApiError
     */
    public static getItemsByShowcaseAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ListOf1OfShowcaseItemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/showcases/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static putShowcaseItemsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutShowcaseItemRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcases/{id}/items',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShowcaseDetails`
     * @returns ShowcaseAdminDto OK
     * @throws ApiError
     */
    public static getShowcaseAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ShowcaseAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/showcases/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns ShowcaseAdminDto OK
     * @throws ApiError
     */
    public static putShowcaseAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutShowcaseRequestAdmin,
    }): CancelablePromise<ShowcaseAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteShowcaseAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/showcases/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShowcases`
     * @returns Pagination1OfShowcaseAdminListedDto OK
     * @throws ApiError
     */
    public static getShowcasesAdmin({
        id,
        name,
        type,
        modeType,
        channelId,
        ignoreChannelOption,
        branchId,
        itemId,
        scopeType,
        page,
        limit,
    }: {
        id?: number,
        name?: string,
        type?: ShowcaseType,
        modeType?: ShowcaseModeType,
        channelId?: number,
        ignoreChannelOption?: boolean,
        branchId?: number,
        itemId?: number,
        scopeType?: ScopeType,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShowcaseAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/showcases',
            query: {
                'id': id,
                'name': name,
                'type': type,
                'modeType': modeType,
                'channelId': channelId,
                'ignoreChannelOption': ignoreChannelOption,
                'branchId': branchId,
                'itemId': itemId,
                'scopeType': scopeType,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns ShowcaseAdminDto Created
     * @throws ApiError
     */
    public static postShowcaseAdmin({
        requestBody,
    }: {
        requestBody?: PostShowcaseRequestAdmin,
    }): CancelablePromise<ShowcaseAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/showcases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static putShowcaseOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutShowcaseOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcases/{id}/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShowcases`
     * @returns any OK
     * @throws ApiError
     */
    public static putShowcaseBranchOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutShowcaseBranchOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/showcases/{id}/branches/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
